"use strict";
import React from "react";

class InfiniteScroll extends React.Component {
    componentDidMount() {
        $(window).on('scroll', this.handleScroll);
    }

    handleScroll = () => {
        this.props.onScroll();
    };

    render() {
        return <div>{this.props.children}</div>;
    }
}

module.exports = InfiniteScroll;